import { queryOptions, skipToken } from '@tanstack/react-query';
import { QueryKey } from 'core/react-query/queryClient';
import { getUrlPreview } from 'networking/mindfeed/services/cortex.service';

// The Open Graph preview (title, image, description) for a link. No URL:
// defined, never runs.
export const urlPreviewQuery = (targetUrl?: string) =>
  queryOptions({
    queryKey: [QueryKey.URL_PREVIEW, targetUrl],
    queryFn: targetUrl ? () => getUrlPreview(targetUrl) : skipToken,
    retry: false,
    // Open Graph metadata for a given URL is effectively immutable, so never
    // treat it as stale. Without this, React Query's default staleTime of 0
    // makes every remount (switching boxes, scrolling link memos in and out of
    // the virtualised list) fire a background refetch — the duplicate
    // /cortex/preview requests and the preview-image flicker. Keep it cached
    // for a day so box switches reuse the result instead of re-hitting Cortex.
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24,
  });
